import React, { useState } from 'react';
import { FiX, FiMinus, FiPlus } from 'react-icons/fi';
import { useCart } from '../../contexts/CartContext';
import { useAuth } from '../../contexts/AuthContext';
import './ProductDetailModal.scss';

const ProductDetailModal = ({ product, isOpen, onClose, onLoginRequired }) => {
  if (!isOpen || !product) return null;

  const { addToCart, updateQuantity, getItemQuantity, removeFromCart } = useCart();
  const { isAuthenticated } = useAuth();
  const [quantity, setQuantity] = useState(1);
  const [showSuccess, setShowSuccess] = useState(false);

  const cartQuantity = getItemQuantity(product.id);
  const isOutOfStock = product.current_stock <= 0;

  const handleQuantityChange = (delta) => {
    const newQuantity = Math.max(1, Math.min(quantity + delta, product.current_stock || 999));
    setQuantity(newQuantity);
  };

  const handleAddToCart = () => {
    if (!isAuthenticated) {
      if (onLoginRequired) {
        onLoginRequired();
      }
      onClose();
      return;
    }

    if (isOutOfStock) {
      return;
    }

    addToCart(product, quantity);
    setShowSuccess(true);
    setTimeout(() => {
      setShowSuccess(false);
      onClose();
    }, 1500);
  };

  return (
    <div className="product-detail-overlay" onClick={onClose}>
      <div className="product-detail-modal" onClick={(e) => e.stopPropagation()}>
        <button className="product-detail-modal__close" onClick={onClose}>
          <FiX />
        </button>

        <div className="product-detail-modal__content">
          <div className="product-detail-modal__image-section">
            {product.imagen_url ? (
              <img
                src={product.imagen_url}
                alt={product.nombre}
                className="product-detail-modal__image"
              />
            ) : (
              <div className="product-detail-modal__image-placeholder">
                <span>📦</span>
              </div>
            )}

            <div className="product-detail-modal__badges">
              {product.es_nuevo && (
                <span className="badge badge--new">NUEVO</span>
              )}
              {product.descuento > 0 && (
                <span className="badge badge--discount">-{product.descuento}%</span>
              )}
            </div>
          </div>

          <div className="product-detail-modal__info-section">
            <div className="product-detail-modal__header">
              <h2 className="product-detail-modal__title">{product.nombre}</h2>
              {product.codigo && (
                <span className="product-detail-modal__code">Código: {product.codigo}</span>
              )}
            </div>

            {product.descripcion && (
              <div className="product-detail-modal__description">
                <h3>Descripción</h3>
                <p>{product.descripcion}</p>
              </div>
            )}

            <div className="product-detail-modal__details">
              <h3>Detalles del Producto</h3>
              <div className="details-grid">
                {product.categoria && (
                  <div className="detail-item">
                    <span className="label">Categoría:</span>
                    <span className="value">{product.categoria}</span>
                  </div>
                )}
                {product.presentacion && (
                  <div className="detail-item">
                    <span className="label">Presentación:</span>
                    <span className="value">{product.presentacion}</span>
                  </div>
                )}
              </div>
            </div>

            {product.precio_venta && (
              <div className="product-detail-modal__price-section">
                {product.precio_anterior && (
                  <span className="price-old">${parseFloat(product.precio_anterior).toFixed(2)}</span>
                )}
                <span className="price-current">${parseFloat(product.precio_venta).toFixed(2)}</span>
              </div>
            )}

            {isAuthenticated && (
              <div className="product-detail-modal__actions">
                <div className="quantity-selector">
                  <button
                    className="quantity-btn"
                    onClick={() => handleQuantityChange(-1)}
                    disabled={quantity <= 1}
                  >
                    <FiMinus />
                  </button>
                  <span className="quantity-display">{quantity}</span>
                  <button
                    className="quantity-btn"
                    onClick={() => handleQuantityChange(1)}
                    disabled={quantity >= (product.current_stock || 999)}
                  >
                    <FiPlus />
                  </button>
                </div>

                <button
                  className={`add-to-cart-btn ${isOutOfStock ? 'add-to-cart-btn--disabled' : ''}`}
                  onClick={handleAddToCart}
                  disabled={isOutOfStock}
                >
                  {isOutOfStock ? 'Agotado' : `Agregar ${quantity} al carrito`}
                </button>
              </div>
            )}

            {!isAuthenticated && (
              <div className="product-detail-modal__footer">
                <p className="footer-note">
                  Inicia sesión para realizar pedidos y acceder a precios exclusivos
                </p>
                <button className="login-cta-btn" onClick={() => {
                  if (onLoginRequired) onLoginRequired();
                  onClose();
                }}>
                  Iniciar Sesión
                </button>
              </div>
            )}

            {showSuccess && (
              <div className="success-overlay">
                <div className="success-message">
                  Producto agregado al carrito
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailModal;
